import gql from 'graphql-tag';

export default gql`
  query invoiceHistoryContent(
    $moduleName: String
    $selectedRow: AccountRowInput
  ) {
    invoiceHistoryContent(moduleName: $moduleName, selectedRow: $selectedRow) {
      InvoiceNo
      Type
      InvoiceDate
      Item
      Description
      Cases
      Price
      Total
      Comment
      Varietal
      Country
      Region
      Appellation
      MasterVendor
      BMFocus
    }
  }
`;
